import {Visibility} from "./global/Visibility";
import {RegionSelector} from "./pollenCount/RegionSelector";
import {PollenCountWidget} from "./pollenCount/PollenCountWidget";
import {IPLocationService} from "./services/location/IPLocationService";
import {RegionService} from "./services/region/RegionService";



/**
 * The main js Application
 */
export class App {

    private pollenCountWidget: PollenCountWidget;
    private regionSelector: RegionSelector;
    /**
     * Runs the application
     */
    public run() {
        this.registerGlobals();

        jQuery(document).ready(() => {
            this.pollenCountWidget = new PollenCountWidget();
            this.pollenCountWidget.initialize();
            this.regionSelector = new RegionSelector(this.pollenCountWidget, new IPLocationService(), new RegionService());
            this.regionSelector.initialize();
        });
    }

    /**
     * Execute javascript in the admin dashboard
     */
    public runAdmin() {
        jQuery(document).ready(($) => {
            // register all date pickers on the page
            $(".datepicker").datepicker({
                dateFormat : "mm-dd-yy"
            });
        });
    }

    /**
     * Register global methods and objects here
     */
    protected registerGlobals() {
        Visibility.initialize(this.getPluginNameSpace());
        Visibility.add('App', this);

    }

    /**
     * Converts the plugin directory name to PascalCasing to use as a global namespace
     * ex. lg-plugin-name -> LGPluginName
     * @returns {string}
     */
    protected getPluginNameSpace() {
        let scripts = document.getElementsByTagName('script');
        let index = scripts.length - 1;
        let myScript = scripts[index];
        let src =  myScript.src;
        let directories = src.split('/');
        let lastDirectory = '';
        let nextIsFound = false;
        let pluginDirectory : string = null;
        for( let directory of directories) {
            if(nextIsFound)
            {
                pluginDirectory = directory;
                break;
            }
            if(directory == 'plugins' && lastDirectory == 'wp-content')
                nextIsFound = true;
            lastDirectory = directory;
        }
        let vendorPrefix  = pluginDirectory.substring(0, pluginDirectory.indexOf('-')).toUpperCase();
        let restOfName = pluginDirectory.substring(pluginDirectory.indexOf('-'));
        let namespaceName = vendorPrefix + restOfName.replace(/(-\w)/g, (m) => m[1].toUpperCase() );
        return namespaceName;
    }
}




// WEBPACK FOOTER //
// ./assets/ts/src/App.ts